module.exports = __webpack_public_path__ + "static/media/scott-simplified 1.72b2b508.png";